import React, { useContext } from "react";
import Features from "../Features";

import "./style.scss";
import Tag from "../Tag";
import Tags from "../Tags";
import { LanguageContext, text } from "../../container/language";

const CardHero = ({ data }) => {
  const {
    cardName,
    image: { url },
    features,
    tags,
    contactless,
    applyonline,
    description,
  } = data;
  const { userLanguage } = useContext(LanguageContext);
  return (
    <ul className="card-list card-list--sb">
      <li className="card-list__item">
        <div className="card-list__item-preview">
          <svg
            className="card-list__hexagon"
            xmlns="http://www.w3.org/2000/svg"
            width="251"
            height="289"
            viewBox="0 0 251 289"
          >
            <path d="M125.5,289L0.36,216.75V72.25L125.5,0,250.64,72.25v144.5Z"></path>
          </svg>
          <div className="card-slider js-card-slider">
            <div className="js-card-slider__carousel">
              <div
                className="card-slider__item"
                style={{
                  willChange: "transform",
                  transform: "perspective(300px) rotateX(0deg) rotateY(0deg)",
                }}
              >
                <img src={url} className="card-list__item-preview-img" />
              </div>
            </div>
          </div>
        </div>
        <div className="card-list__item-text">
          {tags && <Tags data={tags} />}
          <div className="card-item__title">
            <font>
              <font>{cardName}</font>
            </font>
            {contactless && <i class="icon i-PayPass-PayWave" style={{marginLeft: "5px"}}></i>}
          </div>

          <div className="card-item__type">
            <font>
              <font>{text(description, userLanguage)}</font>
            </font>
          </div>

          <Features
            data={features}
            down={true}
            wrapperProps={{ horizontal: true, four: true }}
          />
        </div>
      </li>
    </ul>
  );
};

export default CardHero;
